import React from 'react'
import FooterSectionFive from './FooterSection/FooterSectionFive'
import FooterSectionFour from './FooterSection/FooterSectionFour'
import FooterSectionOne from './FooterSection/FooterSectionOne'
import FooterSectionThree from './FooterSection/FooterSectionThree'
import FooterSectionTwo from './FooterSection/FooterSectionTwo'

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <FooterSectionOne/>
            </div>
            <div className="col-md-2">
              <FooterSectionTwo/>
            </div>
            <div className="col-md-2">
              <FooterSectionThree/>
            </div>
            <div className="col-md-2">
              <FooterSectionFour/>
            </div>
            <div className="col-md-3">
              <FooterSectionFive/>
            </div>
          </div>
        </div>
      </footer>

    </>
  )
}

export default Footer